// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 148,
  argument: "All creatures are invited to praise their Creator.",
  verses: [
    { n: 1, text: "Alleluia. Praise ye the Lord from the heavens: praise ye him in the high places." },
    { n: 2, text: "Praise ye him, all his angels: praise ye him, all his hosts." },
    { n: 3, text: "Praise ye him, O sun and moon: praise him, all ye stars and light." },
    { n: 4, text: "Praise him, ye heavens of heavens: and let all the waters that are above the heavens 5 praise the name of the Lord. For he spoke, and they were made: he commanded, and they were created." },
    { n: 6, text: "He hath established them for ever, and for ages of ages: he hath made a decree, and it shall not pass away." },
    { n: 7, text: "Praise the Lord from the earth, ye dragons, and all ye deeps." },
    { n: 8, text: "Fire, hail, snow, ice, stormy winds, which fulfil his word." },
    { n: 9, text: "Mountains and all hills, fruitful trees and all cedars." },
    { n: 10, text: "Beasts and all cattle: serpents and feathered fowls." },
    { n: 11, text: "Kings of the earth, and all people: princes and all judges of the earth." },
    { n: 12, text: "Young men and maidens: let the old with the younger, praise the name of the Lord: 13 for his name alone is exalted." },
    { n: 14, text: "The praise of him is above heaven and earth: and he hath exalted the horn of his people. A hymn to all his saints: to the children of Israel, a people approaching to him. Alleluia." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Alleluia. Septuagint, Syriac, &c., add, \"of Agg�us and Zacharias,\" as it seems to have been composed after the captivity,", attribution: "Haydock" }
    ] },
    { verse: 13, notes: [
      { text: "(Calmet) — But why might not David thus invite all to praise God? He descends from the highest creatures to those on earth. (Berthier) — Heavens. All ye blessed spirits, preach God for the excellence of your nature, and for your numbers.", attribution: "Worthington" }
    ] },
    { verse: 2, notes: [
      { text: "Hosts. Stars, (Calmet) or rather angels. (St. Chrysostom) (Matthew xxvi. 52.) — The three children made the same invitation to them, rejoicing in this holy communion. [Daniel iii.]", attribution: "Berthier" }
    ] },
    { verse: 3, notes: [
      { text: "And light. Hebrew, \"of light,\" meaning the planets. (Kimchi) — The harmony of these things invites us to praise the Lord. Origen and St. Hilary seem to represent them as intelligent. But (Calmet) when God is praised on their account....they all praise him. (St. Augustine) — Irrational things shew forth the excellence of their Creator.", attribution: "Worthington" }
    ] },
    { verse: 4, notes: [
      { text: "Of heavens. The highest and most excellent, (Calmet) though not the abode of the angels, which had been specified before. — Heavens, in the clouds. It is not necessary to allow these waters to be above the stars.", attribution: "Berthier" }
    ] },
    { verse: 5, notes: [
      { text: "He spoke, and they were made, is not in Hebrew or Chaldean, being taken from Psalm xxxii. 9., (Calmet) or lost in the original.", attribution: "Berthier" }
    ] },
    { verse: 6, notes: [
      { text: "Away. The heavenly bodies observe the most constant order. (Haydock) — They are not liable to change, like sublunary things, (Calmet) though God may suspend the laws which he has established.", attribution: "Berthier" }
    ] },
    { verse: 7, notes: [
      { text: "Earth. All ye inhabitants. (Haydock) — He then addresses whales, and all in the seas.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Word. For the punishment of the wicked, (Calmet) and to strike the saints with awe.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Mountains. Thales, Origen, &c., have attributed souls to waters, &c. But this cannot be proved from this poetical personification.", attribution: "Calmet" }
    ] },
    { verse: 11, notes: [
      { text: "Kings, &c. God is to be praised for the diversity of states, whereby the whole community is preserved.", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "Earth. All contribute towards the divine praise. Yet they cannot afford as much as God deserves. — Horn. Glory, (Calmet) or the Messias; though this cannot easily be proved to be the literal sense. (Berthier) — People. Establishing his Church. (Worthington) — Saints. Israelites, (Berthier) particularly the sacred ministers, Deuteronomy iv. 7. (Calmet) — To him. By free-will, assisted by God's grace. (Worthington) (Hebrews xi. 6., and James iv. 8.)", attribution: "Berthier" }
    ] },
  ],
};

export default chapter;
